import TimelineCard from './TimelineCard'

import './DraggedTimelineCard.css'

class DraggedTimelineCard extends TimelineCard {

    protected getClassModifiers() : string[] {
        const mods = super.getClassModifiers();
        mods.push("dragged");

        return mods;
    }
}

export default DraggedTimelineCard;


// WEBPACK FOOTER //
// ./src/App/Elements/DraggedTimelineCard.tsx